import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebase';

export const useReminderCount = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const remindersRef = collection(db, 'users', user.uid, 'reminderQueue');
    const now = new Date();

    // Query for actionable 'sent' reminders
    const sentQ = query(
      remindersRef,
      where('archived', '==', false),
      where('reminderStatus', '==', 'sent')
    );

    // Query for actionable 'snoozed' reminders (snoozedUntil is null or in the past)
    const snoozedQ = query(
      remindersRef,
      where('archived', '==', false),
      where('reminderStatus', '==', 'snoozed'),
      // Firestore does not allow 'or' queries, so we fetch all snoozed and filter in JS
    );

    // Listen for changes in both queries
    const unsubSent = onSnapshot(sentQ, (sentSnap) => {
      // For sent reminders, all are actionable
      const sentCount = sentSnap.size;

      // For snoozed reminders, we need to filter
      const unsubSnoozed = onSnapshot(snoozedQ, (snoozedSnap) => {
        let actionableSnoozed = 0;
        snoozedSnap.forEach(doc => {
          const data = doc.data();
          if (!data.snoozedUntil) {
            actionableSnoozed++;
          } else {
            const snoozedUntil = data.snoozedUntil.toDate ? data.snoozedUntil.toDate() : new Date(data.snoozedUntil);
            if (snoozedUntil <= now) {
              actionableSnoozed++;
            }
          }
        });
        setCount(sentCount + actionableSnoozed);
      });
      // Return the unsubscribe for snoozed
      return unsubSnoozed;
    });

    // Cleanup both listeners
    return () => {
      unsubSent();
    };
  }, []);

  return count;
}; 